<section class="final-cta-section">
  <div class="cta-background">
    <div class="cta-gradient"></div>
    <div class="cta-shapes">
      <div class="cta-shape shape-1"></div>
      <div class="cta-shape shape-2"></div>
      <div class="cta-shape shape-3"></div>
    </div>
  </div>
  <div class="section-container">
    <div class="cta-content">
      <h2 class="cta-title">Ready to Transform Your Educational Experience?</h2>
      <p class="cta-subtitle">
        Join thousands of educational institutions already using Tenjah School
        to enhance learning outcomes and streamline operations.
      </p>
      <div class="cta-actions">
        <a routerLink="/register" class="primary-cta large">
          <span class="cta-icon">🚀</span>
          <span class="cta-text">Start Free Trial</span>
          <div class="cta-ripple"></div>
        </a>
        <button (click)="smoothScroll('about', $event)" class="secondary-cta outline">
          <span class="cta-text">Learn More</span>
        </button>
      </div>
      <div class="cta-note">
        <span class="note-text">✨ No credit card required • 14-day free trial</span>
      </div>
    </div>
  </div>
</section>